import { MutationOptions } from '@tanstack/react-query';
import { ActivateQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/activate/activateQueryFunction';
import { MutationVariables } from '@/modules/adjusterReportModules/IncidentParticipants/queries/activate/activateQuery.type';
import { AxiosResponse } from 'axios';

export const activateMutationOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  MutationVariables
> => {
  return {
    mutationKey: ['activate-participants-incident'],
    mutationFn: ({ id, formData }: MutationVariables) =>
      ActivateQueryFunction(id, formData),
  };
};
